import Axios from 'axios';
import header from './auth/header'

const API_URL =  process.env.API_URL + '/api/v1/';

class FunderAttachment {
  update(data) {
    return Axios.patch(API_URL + 'update-nonpersonal', data, { headers: header() });
  }
}

export default new FunderAttachment();



// WEBPACK FOOTER //
// ./src/api/funderattachment.js